import BaseService from '../base'

export default class AccountBeneficiariesService extends BaseService {
  static resource() {
    return 'api/v1/external/accountBeneficiaries'
  }
}
